import { Prediction } from "@/model/data/predictiveMaintenance/Prediction";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetLastMachinePredictedStatusResData extends ApiGenericResponse {
    predictions: Prediction[];
    probabilityWarningThreshold: number;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Predictions) {
            this.predictions = new Array<Prediction>();
            obj.Predictions.forEach((element) => {
                let p = new Prediction();
                p.parse(element);
                this.predictions.push(p);
            });
        }
        if (obj.ProbabilityWarningThreshold) this.probabilityWarningThreshold = obj.ProbabilityWarningThreshold;
    }
}
